
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/forgot-password",
      function () {
        return require("private-next-pages/partners/forgot-password.js");
      }
    ]);
  